import { Modal, Button } from 'react-bootstrap';

interface IProps {
    show: boolean,
    centerAlias: string,
    onYes: () => void,
    onNo: () => void
}

const OverrideAnatomyPreference = (props: IProps) => {
    const centerAlias = props.centerAlias.substring(props.centerAlias.length - 1).toUpperCase() != 'S' ? `${props.centerAlias}'s` : `${props.centerAlias}'`;

    return (
        <Modal backdrop='static' show={props.show} onHide={props.onNo}>
            <Modal.Header closeButton>
                <Modal.Title>Override Center's Anatomy Preference</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                Are you sure you wish to override {centerAlias} anatomy preference to make this chain end offer?
            </Modal.Body>

            <Modal.Footer>
                <Button bsStyle="primary" onClick={props.onYes}>Yes</Button>
                <Button onClick={props.onNo}>No</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default OverrideAnatomyPreference;